/**
 * Default Bitrix24 custom-field names for Aelo analysis results.
 *
 * ONE map read by every side of the same contract: `POST /bitrix24/fields`
 * (edge-api) creates a field under this name, `Bitrix24CrmDeliveryProvider.resolveFieldId`
 * (connectors) writes to it when the org has no explicit mapping, and the
 * embedded `useDeliveryConfig` (ui-worker) names it. Two copies of the names
 * drifted once (delivery wrote UF_CRM_AICA_QUALITYSCORE while the endpoint
 * created UF_CRM_AICA_QUALITY, #1668).
 *
 * The names are what portals already carry — do not rename an entry.
 */
export const BITRIX24_DEFAULT_FIELD_NAMES = {
  transcript: 'UF_CRM_AICA_TRANSCRIPT',
  summary: 'UF_CRM_AICA_SUMMARY',
  qualityScore: 'UF_CRM_AICA_QUALITY',
  saleProbability: 'UF_CRM_AICA_SALE_PROB',
  keywords: 'UF_CRM_AICA_KEYWORDS',
  sentiment: 'UF_CRM_AICA_SENTIMENT',
} as const satisfies Record<string, string>;

export type Bitrix24DefaultFieldKey = keyof typeof BITRIX24_DEFAULT_FIELD_NAMES;

/**
 * The default Bitrix24 field name for a generic field key: the map above, or
 * `UF_CRM_AICA_<KEY>` for a key outside it.
 */
export function bitrix24DefaultFieldName(genericField: string): string {
  return Object.prototype.hasOwnProperty.call(BITRIX24_DEFAULT_FIELD_NAMES, genericField)
    ? BITRIX24_DEFAULT_FIELD_NAMES[genericField as Bitrix24DefaultFieldKey]
    : `UF_CRM_AICA_${genericField.toUpperCase()}`;
}
